import LayersIcon from './component'

export default LayersIcon
